import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  VStack,
  HStack,
  Input,
  Textarea,
  FormControl,
  FormLabel,
  Text,
  Alert,
  AlertIcon,
  useToast,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { sendSMSAction } from "../redux/actions/smsActions";
import { formatMobile } from "../global-client";

const MissedCallMessageScreen = () => {
  const [missedCallMessage, setMissedCallMessage] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const toast = useToast();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchSetup();
  }, []);

  const fetchSetup = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/api/setup");
      setMissedCallMessage(data.missedCallMessage || "");
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to load setup configuration",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSendMessage = async () => {
    if (!mobileNumber.trim()) {
      toast({
        title: "Error",
        description: "Please enter a mobile number",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (!missedCallMessage.trim()) {
      toast({
        title: "Error",
        description: "Please enter a message",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setSending(true);
      const smsData = {
        to: mobileNumber,
        body: missedCallMessage,
        delayOption: "0", // Immediate send, but do not record as job-related
        from: "+61407103182", // Twilio number
        jobNumber: 0,
        scheduledFor: null,
        flags: []
      };

      await dispatch(sendSMSAction(smsData));

      toast({
        title: "Success",
        description: "Missed call message sent successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      // Clear the mobile number after successful send
      setMobileNumber("");
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to send message",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <Box p={4}>
      <VStack spacing={6} align="stretch">
        <Alert status="info">
          <AlertIcon />
          Send a missed call message to a customer. The message text is loaded from setup but can be edited.
        </Alert>

        <FormControl>
          <FormLabel fontSize="md" fontWeight="semibold">
            Customer Mobile Number
          </FormLabel>
          <Input
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            placeholder="Enter mobile number (e.g., 0412345678)"
            size="lg"
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize="md" fontWeight="semibold">
            Message Text
          </FormLabel>
          <Textarea
            value={missedCallMessage}
            onChange={(e) => setMissedCallMessage(e.target.value)}
            placeholder="Enter the missed call message..."
            size="lg"
            minH="120px"
            resize="vertical"
          />
          <Text fontSize="sm" color="gray.500" mt={2}>
            Characters: {missedCallMessage.length}
          </Text>
        </FormControl>

        <HStack spacing={4}>
          <Button
            colorScheme="blue"
            onClick={handleSendMessage}
            isLoading={sending}
            loadingText="Sending..."
            size="lg"
          >
            Send Message
          </Button>
        </HStack>
      </VStack>
    </Box>
  );
};

export default MissedCallMessageScreen;